import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserThree = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7Z",
			fill: "#3B82F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 18.75C5 16.1266 7.12665 14 9.75 14H14.25C16.8734 14 19 16.1266 19 18.75C19 20.5449 17.5449 22 15.75 22H8.25C6.45507 22 5 20.5449 5 18.75Z",
			fill: "#3B82F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.98264 3.938C6.18176 3.54759 6.10348 3.07302 5.78952 2.76725C5.47557 2.46149 4.9991 2.39577 4.61409 2.60514C3.05908 3.45075 2 5.10097 2 7.00003C2 8.89906 3.05906 10.5493 4.61404 11.3949C4.99904 11.6043 5.47551 11.5385 5.78947 11.2328C6.10343 10.927 6.18172 10.4525 5.98261 10.062C5.51445 9.14414 5.25 8.10444 5.25 7.00006C5.25 5.89565 5.51447 4.85592 5.98264 3.938Z",
			fill: "#3B82F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3859 2.60514C19.0009 2.39577 18.5244 2.46149 18.2105 2.76726C17.8965 3.07303 17.8182 3.5476 18.0174 3.938C18.4855 4.85592 18.75 5.89565 18.75 7.00006C18.75 8.10443 18.4855 9.14414 18.0174 10.062C17.8183 10.4524 17.8966 10.927 18.2105 11.2328C18.5245 11.5385 19.001 11.6043 19.386 11.3949C20.9409 10.5493 22 8.89906 22 7.00003C22 5.10097 20.9409 3.45076 19.3859 2.60514Z",
			fill: "#3B82F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.92491 15.8622C4.11736 15.4748 4.039 15.0077 3.7307 14.7044C3.4224 14.401 2.95404 14.3303 2.56989 14.529C1.04548 15.3176 0 16.9109 0 18.75C0 20.2486 1.01342 21.508 2.39054 21.8849C2.75482 21.9846 3.1442 21.8706 3.39715 21.5901C3.65009 21.3097 3.72345 20.9106 3.58679 20.5585C3.36962 19.999 3.25 19.3897 3.25 18.7501C3.25 17.7107 3.49321 16.731 3.92491 15.8622Z",
			fill: "#3B82F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4301 14.529C21.046 14.3303 20.5776 14.401 20.2693 14.7044C19.961 15.0077 19.8826 15.4748 20.0751 15.8622C20.5068 16.731 20.75 17.7107 20.75 18.7501C20.75 19.3897 20.6304 19.999 20.4132 20.5585C20.2765 20.9106 20.3499 21.3097 20.6029 21.5901C20.8558 21.8706 21.2452 21.9846 21.6095 21.8849C22.9866 21.508 24 20.2486 24 18.75C24 16.9109 22.9545 15.3176 21.4301 14.529Z",
			fill: "#3B82F6"
		})
	]
});
const ForwardRef = forwardRef(SvgUserThree);
export default ForwardRef;
